export interface FeatureFlags {
  isRustled: boolean;
}

export enum FeatureParam {
  RUSTLED = "rustled",
  DISTRIBUTION_FORECASTING = "distForecasting",
}
